module.exports = __webpack_public_path__ + "media/src/images/icon__magazinHappy1-92ba82e322d55ab2211c7d3c58b15100.svg";